/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import React from 'react';

import {OverviewStock} from '../../../../util/interfaces';

import {getOverviewStock} from '../../../../util/requestSender';

import {useOverviewSection} from '../useOverviewSection';

import LowStock from './lowStock';

interface Props {
    accountIds: Array<string>;
}

// Stock is not period-scoped (overview-openapi decision 4): the endpoint simply
// returns the products with the lowest stock.
export default function LowStockController({accountIds}: Props) {
    const section = useOverviewSection<OverviewStock>({request: getOverviewStock, accountIds});

    return <LowStock {...section} />;
}
